export const notificationCenter = {
  markAsRead: "Mark as read",
  activity: "Activity",
  read: "Read",
  unread: "Unread",
};
